<template>
    <div v-if="cargando">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3> 
            </div>
        </div>
    </div>
    <div v-else>
    <br>
    <b-row>
        <b-col md="2">
            <b-form-group label-cols="2" label="Orden" class="mb-0">
                <b-input-group>
                <b-form-select v-model="orden" slot="append" @input="listGuide">
                    <option :value="'asc'">Más Antiguo</option>
                    <option :value="'desc'">Más Reciente</option>
                </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col cols="1" sm="2"	md="2"	lg="2"	xl="3">
            <b-form inline>
                Desde: <b-input type="date" v-model="f1"/>
                Hasta: <b-input type="date" v-model="f2"/>
            </b-form>
        </b-col>
        <b-col>
          <b-button @click="listGuide" variant="success">Buscar</b-button>
        </b-col>
        <b-col md="2">
            <div class="col-md-12 text-center">
                <b-button variant="secondary" @click="listGuide"><i class="fa fa-sync-alt"></i> </b-button>
            </div>
        </b-col>
        <b-col md="2">
            <b-form-group label-cols="3" label="Mostrar" class="mb-0">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listGuide">
                    <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>                            
                </b-input-group>                        
            </b-form-group>                    
        </b-col>
    </b-row>
    <br>
    <b-table
        responsive 
        :small="small"
        :outlined="outlined"
        :items="guides"
        :fields="guides_fields"
        :current-page="pactual"
        :per-page="limite"            
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection" 
        >
        <template slot="estado" slot-scope="row">
            <div v-if="row.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
            <div v-else-if="row.item.emitido==0"><span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"></i></span></div>
            <div v-else-if="row.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
        </template>
        <template slot="receptor" slot-scope="row">
            <template v-if="row.item.receiver">
                {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
            </template>
            <template v-else>
                {{ row.item.idReceptor }}
            </template>            
        </template>
        <template slot="emision" slot-scope="row">
            {{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }} 
        </template>
        <template slot="moneda" slot-scope="row">
            <template v-if="row.item.tipoMoneda=='PEN'">S/</template>
            <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
            <template v-else>{{ row.item.tipoMoneda }}</template>                     
            {{row.item.totalVentaGravada}}
        </template>
        <template slot="acciones" slot-scope="row">
            <template v-if="row.item.emitido!=2">
                <b-button-group>
                    <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth"><i class="fa fa-spin fa-spinner"></i></b-button>
                    <b-button size="sm" v-b-modal.modalprev @click="viewPdf(row.item)" title="Vista Previa"><i class="fa fa-tv"></i></b-button>
                    <b-button size="sm" @click="setInvoice(row.item)" v-b-modal.sendfacturaemail1 title="Compartir Documento"><i class="fa fa-share-alt" aria-hidden="true"></i></b-button>
                    <b-button size="sm" @click="downloadPdf(row.item)" title="Descargar PDF"><i class="fa fa-file-pdf"></i></b-button>                        
                    <b-button size="sm" v-if="row.item.emitido==0" class="disabled" :disabled="true" title="Descargar CDR"><i class="fa fa-file-archive"></i></b-button>
                    <b-button size="sm" v-else @click="downloadCdr(row.item)" title="Descargar CDR"><i class="fa fa-file-archive"></i></b-button>
                    <b-button size="sm" v-if="row.item.emitido==0" class="disabled" :disabled="true" title="Descargar XML"><i class="fa fa-file-code"></i></b-button>
                    <b-button size="sm" v-else @click="downloadXml(row.item)" title="Descargar XML"><i class="fa fa-file-code"></i></b-button>
                    <b-button size="sm" variant="success" @click="copiPaste(row.item, 1)" title="Duplicar Guia"><i class="fa fa-1x fa-copy"></i></b-button>
                    <b-button size="sm" variant="dark" @click="copiPaste(row.item, 2)" title="Convertir a Factura"><b>F</b></b-button>
                </b-button-group>
            </template>
            <template v-else>
                <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                </button>
                <b-button-group>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth"><i class="fa fa-spin fa-spinner"></i></b-button>
                    <b-button size="sm" @click="downloadCdr(row.item)" title="Descargar CDR"><i class="fa fa-file-archive"></i></b-button>
                    <b-button size="sm" v-if="row.item.emitido==2" @click="estadoEmision(row.item)" v-b-modal.motivorechazo7 title="Estado de Emisión" variant="primary"><i class="fa fa-eye text-white"></i></b-button>
                    <b-button size="sm" variant="success" @click="copiPaste(row.item, 1)" title="Duplicar Guia"><i class="fa fa-1x fa-copy"></i></b-button>
                    <b-button size="sm" variant="dark" @click="copiPaste(row.item, 2)" title="Convertir a Factura"><b>F</b></b-button>
                </b-button-group>
            </template>
        </template>
        <template slot="row-details" slot-scope="row">
                <b-table 
                    head-variant="light"
                    small
                    bordered
                    :items="row.item.lista" 
                    :fields="listaitems_fields" 
                    :busy="row.item.loading">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="index" slot-scope="row">
                        {{ row.index+1 }}
                    </template>
                    <template slot="cantidad" slot-scope="row">
                            {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                    </template>
                    <template slot="precioVentaUnitario" slot-scope="row">
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.precioVentaUnitario">
                                {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                            </template>  
                    </template>
                    <template slot="descuento" slot-scope="row">                     
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.descuento">
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            <template v-else>
                                0.00
                            </template>                    
                    </template>     
                    <template slot="valorVenta" slot-scope="row">                      
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.valorVenta">
                                {{ Number.parseFloat(row.item.valorVenta*($store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) }}
                            </template>                      
                    </template>
                </b-table>
        </template>           
    </b-table>
        <b-modal id="modalguide" title="Compartir Documento" v-model="previacorreo">
            <div role="group">
                <label for="inputLive">Enviar por Correo: <i class="fa fa-envelope fa-lg" aria-hidden="true"></i></label>
                <b-form-input 
                    style="border-color:black" 
                    v-model="recipients" type="email" 
                    @keyup.enter="sendMail(guide)"
                    placeholder="Ingresa un correo ó varios separados por comas (,)">
                </b-form-input>
                <b-form-text 
                    style="font-size: small !important; color: #ea0909 !important">
                    Ingresa un correo ó varios separados por comas (,)
                </b-form-text>
            </div>
            <b-row>
                <b-col>
                    <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail(guide)">Enviar</b-btn>
                    <b-btn v-else size="sm" class="float-right" variant="secondary"><i class="fa fa-spin fa-spinner"></i> Enviando...</b-btn>
                </b-col>
                <!-- <b-col v-else>
                   <b-button class="float-right" disabled variant="secondary" size="sm" > Enviar</b-button>
                </b-col> -->
            </b-row>
            <hr class="mt-3">
            <h5>Correos en módulo Negocios:</h5>
            <h5><li style="list-style:none" class="mr-1" variant="dark" v-for="(item,index) in reciveEmail" :key="index">
                <b-badge pill variant="light">{{item}}
                <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
                </li>
            </h5>
            <b-row>
                <b-col v-if="!sendcorreoNegocios">
                    <b-button v-if="recipients!=''" :disabled="mostraremail" class="float-right" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar a todos</b-button>
                    <b-button v-else  :disabled="mostraremail" class="float-right" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar</b-button>
                </b-col>
                <b-col v-else-if="sendcorreoNegocios">
                    <b-buttom class="float-right"> <i class="fa fa-spin fa-spinner"></i> Enviando... </b-buttom>
                </b-col>
            </b-row>
            <div slot="modal-footer"></div>
        </b-modal>  
        <b-modal id="motivorechazo7" title="Motivo del Rechazo" v-model="motivoRechazo">
            <div role="group">
                <div v-if="spinoff">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h6>{{ descripcionRechazo }}</h6>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer" class="w-100">
                <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="motivoRechazo=!motivoRechazo">
                    Ok
                </b-btn>
            </div>
        </b-modal>           
        <b-modal id="modalprev" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previaguia">
            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
            <template v-else>
                <template v-if="pdfobject !==''">
                <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                </template>
            </template>                
        </b-modal>
    <div class="row">
        <div class="col-md-9">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-3">
            <b-pagination size="md" :total-rows="total" v-model="currentPage" :per-page="limite" @input="listGuide"></b-pagination>
        </div>
    </div>
    <!-- <items-de-guias-a-facturas :capturaItems="enviandoArray"></items-de-guias-a-facturas> -->
    <vue-snotify></vue-snotify>
</div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
// import ItemsDeGuiasAFacturas from '@/components/comunes/ItemsDeGuiasAFacturas'
export default {
    name: 'GuiaRemisionConsulta',
    components:{
        // ItemsDeGuiasAFacturas
    },
    data: () => {
        return {
            motivoRechazo: false,
            spinoff: false,
            descripcionRechazo: '',
            currentPage: 1,
            striped: true,
            outlined: true,
            small: true,
            filter: null,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            guide: {},
            previaguia: false,
            guides: [],
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            guides_fields: [
                {key: 'serie', label: 'Serie', sorteable: true},
                {key: 'numero', label: 'Numero', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'moneda', label: 'Total Gravado', sorteable: true},
                {key: 'estado', label: 'Estado', sorteable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            listaitems_fields: [
                {key: 'index', label: 'N°', sorteable: true},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'unidadMedida', label: 'Emisión', sorteable: true},
                {key: 'descripcion', label: 'Descripcion'},
                {key: 'codigoItem', label: 'Codigo Item', sorteable: true},
                {key: 'codigoProductoSunat', label: 'Codigo Sunat', sorteable: true}
            ],
            pdfobject: '',
            cargandopdf2: false,
            recipients: '',
            cargandopdf: false,
            previacorreo: false,
            sendcorreo: false,
            // cargandocdr: false,
            // enviandoArray:[]
            f1:'',
            f2:'',
            reciveEmail:[],
            customers:[],
            mostraremail: true,
            currentPageTerceros:1,
            ordenTerceros:'desc',
            sendcorreoNegocios:false,
        }
    },
    mounted () {
        this.listGuide();
        this.listTerceros();
    },
    methods: {
        mostrarDetalles: function (row, index) {
            if(row.detailsShowing){
                row.toggleDetails()
                this.guides[index].mostrardetalles = false
            }else{
                this.guides[index].mostrardetalles = true
                this.guides[index].loading = true
                if(this.guides[index].lista.length == 0){
                    setTimeout(() => 
                        this.detallesDocumento(row, index)
                    , 10);  
                }else{
                    this.guides[index].loading = false
                    row.toggleDetails()
                } 
            }
        },
        detallesDocumento: function (row, index) {
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/items',{
                token: this.$store.getters.userToken,
                idguia: row.item.idGuiaRemitente
            })
            .then(response => (
                this.parseDetallesDocumento(response.data.response, row, index),
                this.itemGuiaDuplicada(response.data.response)
            ))
            .catch(error => (  
                this.guides[index].mostrardetalles = false
            )) 
        },
        parseDetallesDocumento: function (value, row, index) {
            this.guides[index].lista = []
            for (let i=0; i<value.length; i++){
                value[i].moneda = row.item.tipoMoneda
                this.guides[index].lista.push(value[i])
            }
            this.guides[index].loading = false
            // this.guides[index].mostrardetalles = false
            if(value.length > 0){
                row.toggleDetails()
            }
        },
        setGuide: function (data) {
            this.guide = data
        },
        listGuide: function () {
            let dia1;
            let dia2;
            if(this.f1 === "" && this.f2 ===""){
                dia1 =  ""
                dia2 = ""
            }else{
                dia1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')          
            }
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente', {
                token: this.$store.getters.userToken,
                f1:dia1,
                f2:dia2,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden

            })
            .then(response => (
                this.guides = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false,
                this.guides.forEach(function(element){
                    element.loading = false
                })
            ))
            .catch(error =>  {})
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'guiaremitente/pdf',{
               token: this.$store.getters.userToken,
               id: data.idGuiaRemitente
           })
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){
               this.$snotify.error(error.response.data.message,'Error')
           })      
        },
        // validarcorreo() {
        //     const regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
        //     return regex.test(this.recipients);
        // },
        sendMail: function () {
            this.invoice;
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/mail', {
                token: this.$store.getters.userToken,
                id: this.invoice.idGuiaRemitente,
                mail: this.recipients 
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.$snotify.success(response.data.msg, 'Exito')          
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'guiaremitente/pdf',{
               token: this.$store.getters.userToken,
               id: data.idGuiaRemitente
           })
           .then(response => {
            const base64 = response.data.base64;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            if (isIOS) {
              window.location.href = url;
            } else {
              const a = document.createElement("a");
              a.href = url;
              a.download = name;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
            setTimeout(() => URL.revokeObjectURL(url), 5000);
            this.cargandopdf = false;
            this.$swal.close();
           })
           .catch(function (error){
               this.$swal.close()
           })            
        },
        setInvoice: function(data) {
            this.previacorreo = true;
            this.invoice = data;
            this.reciveEmail = []
            this.listTerceros();
            let valordata = data
            let pasandoCorreoTerceros = {}
            this.customers.forEach(function(element){
                if(valordata.receiver.idReceptor == element.documento){
                pasandoCorreoTerceros = element.emailEnvio
                }      
            })
            this.reciveEmail = pasandoCorreoTerceros;
            if(this.reciveEmail && this.reciveEmail.length > 0){
                this.mostraremail = false;
            }else{
                this.mostraremail = true;
            }
           
        },
        listTerceros: function() {
        axios
            .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
            token: this.$store.getters.userToken,
            page: this.currentPageTerceros,
            order: this.ordenTerceros
            })
            .then(response =>(
                this.customers = response.data
            ))
            .catch(error => (
            console.log(error)
            ))
        },
        enviarEmail: function(data) {
            for (let i = 0; i < this.reciveEmail.length; i++) {
                this.reciveEmail[i] + ","
            }
            let cadena = this.reciveEmail.join(",");
            if(this.recipients !=''){
                this.sendMail(data);  
            }  
            this.previacorreo = true;
            this.sendcorreoNegocios = true;
            axios
                .post(process.env.VUE_APP_API_URL + "guiaremitente/mail", {
                token: this.$store.getters.userToken,
                id: data.idGuiaRemitente,
                mail: cadena
                })
                .then(
                response => (
                    (this.previacorreo = false),
                    (this.sendcorreoNegocios = false),
                    this.alertaenvio(response.data.msg)
                )
                )
                .catch(
                error => (
                    (this.previacorreo = false),
                    (this.sendcorreoNegocios = false),
                    this.$snotify.error(error.response.data.response, "Error")
                )
                );
        },
        alertaenvio(data){
            if(this.recipients == ''){
                this.$snotify.success(data, "Exito")
            }
        },
        borrarCorreo(index){
            this.reciveEmail.splice(index, 1)
            if(this.reciveEmail.length > 0){
                this.mostraremail = false;
            }else{
                this.mostraremail = true;
            }
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'guiaremitente/cdr',{
               token: this.$store.getters.userToken,
               id: data.idGuiaRemitente
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,               
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){
               
           })    
        },
        // downloadXml: function (data){
        //     let name = data.serie + '-' + data.numero + '.zip'
        //     let file = 'data:application/zip;base64,'+ data.xml           
        //     download(file, name,'application/zip');
        // },
        downloadXml: function (data){
            let xml = ''
            let file = ''
            let name = data.serie + '-' + data.numero + '.zip'
            let tag = document.createElement('i')
            this.cargandopdf = true
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            this.$swal({
            title: 'Obteniendo XML',
            content: tag,
            icon: 'info',
            buttons: false,
            dangerMode: false
            })
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/xml', {
                token: this.$store.getters.userToken,
                id: data.idGuiaRemitente
            })
            .then(response => (
                xml = response.data.response.xml,
                file = 'data:application/zip;base64,'+ xml,
                this.downloadxml(file, name, xml),
                this.$swal.close()
            ))
            .catch(error => (
                this.$snotify.error('Error al descargar el archivo', 'Error')
            ))
        },
        downloadxml: function (file, name, xml) {
            if(xml != null){
                download(file, name,'application/zip')
            }else{
                this.$snotify.error('El documento aun no tiene constancia porque esta en proceso!', 'Error')
            }  
        },
        estadoEmision: function (value) {
            this.spinoff = true
            axios
            .post(process.env.VUE_APP_API_URL + 'documento/motivorechazo', {
                token: this.$store.getters.userToken,
                serie: value.serie,
                numero: value.numero,
                tipo: '09'
            })
            .then(response => ( 
                this.descripcionRechazo = response.data.msg.descripcion,
                this.spinoff = false
            ))
            .catch(error => (
                this.$snotify.error(error.response.data, 'Error'),
                this.motivoRechazo = false,
                this.spinoff = false
            )) 
        },
        copiPaste(datos, num){
            axios
            .post(process.env.VUE_APP_API_URL + 'guiaremitente/items',{
                token: this.$store.getters.userToken,
                idguia: datos.idGuiaRemitente
            })
            .then(response => (
                this.enviadoGuia(datos, response.data.response, num)
            ))
            .catch(error => (  
              console.log('error en duplicar guia items')
            )) 
        },
        enviadoGuia(datos, items, num){
            if(num === 1){ //DUPLICAR GUIA
                this.$store.commit("duplicarGuiaRemision", datos)
                this.$store.commit("duplicarGuiaRemisionItems", items)
                this.changeTab(0);
            }else if(num === 2){ //CONVERTIR A FACTURA
                this.$store.commit("guiaAFacturas", datos)
                this.$store.commit("duplicarGuiaRemisionItems", items)
                this.$router.push("/emision/factura").catch(err => {});
            }
        },
        changeTab: function(value) {
        this.$emit("tabindex", value);
        },      
    }
}
</script>
<style scoped>

</style>

